import { render, staticRenderFns } from "./bindInfo.vue?vue&type=template&id=6c25c3e6&scoped=true"
import script from "./bindInfo.vue?vue&type=script&lang=js"
export * from "./bindInfo.vue?vue&type=script&lang=js"
import style0 from "./bindInfo.vue?vue&type=style&index=0&id=6c25c3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25c3e6",
  null
  
)

export default component.exports